/**
 * Allowlisted remote origins permitted to receive authentication bearer tokens.
 * Same-origin requests (empty string or relative path) are always allowed.
 */
export const ALLOWED_API_ORIGINS: readonly string[] = [
  'https://zunelo.web.app',
  'https://zunelo.firebaseapp.com',
];

export function isAllowedApiOrigin(origin: string): boolean {
  return ALLOWED_API_ORIGINS.includes(origin);
}

/** Shared Functions / local-bff origin. Empty means same-origin `/api/**`. */
export function resolveApiBaseUrl(env: {
  VITE_API_BASE?: string;
  VITE_SLACK_API_BASE?: string;
}): string {
  const candidate = (env.VITE_API_BASE ?? env.VITE_SLACK_API_BASE ?? '').trim();
  if (!candidate) return '';
  if (candidate.startsWith('/')) return candidate.replace(/\/+$/, '');

  try {
    const url = new URL(candidate);
    if (isAllowedApiOrigin(url.origin)) {
      return candidate.replace(/\/+$/, '');
    }
    console.warn(
      `[apiEndpoints] Disallowed API origin ${url.origin} in env. Falling back to same-origin.`,
    );
    return '';
  } catch {
    return '';
  }
}

/** Vite dev-server proxy target for `/api/**`. */
export function resolveApiProxyTarget(env: {
  VITE_API_PROXY_TARGET?: string;
  VITE_SLACK_PROXY_TARGET?: string;
}): string {
  if (env.VITE_API_PROXY_TARGET) return env.VITE_API_PROXY_TARGET;
  if (env.VITE_SLACK_PROXY_TARGET) return env.VITE_SLACK_PROXY_TARGET;
  return 'http://127.0.0.1:8787';
}
